import { render, staticRenderFns } from "./Contrasena.vue?vue&type=template&id=7dbd04e4&scoped=true"
import script from "./Contrasena.vue?vue&type=script&setup=true&lang=js"
export * from "./Contrasena.vue?vue&type=script&setup=true&lang=js"


/* normalize component */
import normalizer from "!../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "7dbd04e4",
  null
  
)

export default component.exports